import { defineComponent } from 'vue';
import { EditorCB } from './EditorCB';
import { setupComponent } from '@studyportals/vue-platform';
import BodyForm from '@/presentation/components/form/BodyForm.vue';

export default defineComponent({
	components: {
		BodyForm,
	},
	setup: () => {
		const codeBehind = new EditorCB();

		return setupComponent(codeBehind);
	},
});
